import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {ReduxFormSelectPickerGeneric} from '../../redux-form-fields/select-picker-generic/select-picker-generic';

import {SelectedFieldCard} from './selected-field-card';

type Props = FieldProps & {
    onRemove: () => void;
    optionFields: {
        id: string;
        name: string;
    }[];
    autoFocus?: boolean;
};

export function SelectField(props: Props) {
    const inputValue = props.input.value;

    const selectedValue = inputValue
        ? // @ts-expect-error
          props.optionFields.find((field) => field.id === inputValue)
        : undefined;

    if (inputValue) {
        return (
            <SelectedFieldCard
                name={selectedValue ? selectedValue.name : inputValue.label}
                onRemove={props.onRemove}
            />
        );
    }

    return <ReduxFormSelectPickerGeneric {...props} />;
}
